import { Avail } from 'pages/Avail';
import { ArchVision } from 'pages/ArchVision';
import { Russwood } from 'pages/Russwood';
import { Home } from 'pages/Home/Home';
import { FOVEA } from 'pages/FOVEA';

const routes = [
  // Private routes
  {
    path: '/archvision/:guid',
    element: <ArchVision />,
    authenticate: true,
  },
  {
    path: '/avail/:guid',
    element: <Avail />,
    authenticate: true,
  },
  {
    path: '/russwood/:guid',
    element: <Russwood />,
    authenticate: true,
  },
  {
    path: '/fovea/:guid',
    element: <FOVEA />,
    authenticate: true,
  },

  // Public routes
  {
    path: '*',
    element: <p>404 Page</p>,
  },
  {
    path: '/',
    element: <Home />,
    authenticate: false,
  },
  {
    path: '/no-access',
    element: <p>No-access</p>,
  },
];

export { routes };
